import { axios } from "./session"

export default class VerkkokauppaService {
  static login = async () => {
    const response = await axios.get('/verkkokauppa/login');
    return response.data.url;
  }
}